import React, { useEffect, useState } from 'react'
import { Autocomplete, TextField, Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material'
import { useDataProvider } from 'react-admin'
import MapsHomeWorkIcon from '@mui/icons-material/MapsHomeWork'

export const FindPropertyDialog = ({ openDialog, onClickAttach, landlordId }) => {
  const [autocompleteValue, setAutocompleteValue] = useState('')
  const [options, setOptions] = useState([])
  const [loading, setLoading] = useState(false)
  const dataProvider = useDataProvider()
  const [open, setOpen] = useState(openDialog)
  const [isDisabled, setIsDisabled] = useState(false)

  const handleClose = () => {
    setOpen(false)
  }

  useEffect(() => {
    dataProvider
      .getList('properties', { filter: { owner_id: landlordId, status: ['draft', 'pending'] } })
      .then(({ data }) => {
        setOptions(data)
        setLoading(false)
      })
      .catch((error) => {
        setLoading(false)
        console.log(error)
      })
  }, [])

  useEffect(() => {
    setIsDisabled(options.length <= 0)
  })

  const getOptionLabel = (option) => {
    if (!option) {
      return ''
    }

    if (!option.address) {
      return `${option?.id}`
    }

    const street = option.address.street ?? ''
    const streetNumber = option.address.streetNumber ?? ''
    const city = option.address.city ?? ''
    const zip = option.address.zip ?? ''
    const province = option.address.province ?? ''
    return `${option?.id} - ${street} ${streetNumber} ${city} ${zip} ${province}`
  }

  const handleClickSearchProperty = () => {
    setOpen(true)
  }

  return (
    <>
      <Button variant="outlined" onClick={handleClickSearchProperty} startIcon={<MapsHomeWorkIcon />} disabled={isDisabled}>
        {'Find property'}
      </Button>
      <Dialog open={open} onClose={handleClose} fullWidth>
        <DialogTitle id="alert-dialog-title">{'Attach Property to Lead'}</DialogTitle>
        <DialogContent>
          <Autocomplete
            value={autocompleteValue}
            options={options}
            getOptionLabel={getOptionLabel}
            autoHighlight={true}
            loading={loading}
            clearOnEscape
            onChange={(event, value) => setAutocompleteValue(value)}
            renderInput={(params) => <TextField {...params} label="Landlord Properties" variant="outlined" />}
            fullWidth
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>{'Cancel'}</Button>
          <Button onClick={() => onClickAttach(autocompleteValue)}>{'Save'}</Button>
        </DialogActions>
      </Dialog>
    </>
  )
}
